__turbopack_context__.v({
  "carousel": "styles-module-scss-module__I1TZaa__carousel",
  "item": "styles-module-scss-module__I1TZaa__item",
  "slideTrack": "styles-module-scss-module__I1TZaa__slideTrack",
  "svg": "styles-module-scss-module__I1TZaa__svg",
  "text": "styles-module-scss-module__I1TZaa__text",
  "wrap": "styles-module-scss-module__I1TZaa__wrap",
});
